import { useVerifyDiscountStatusQuery } from "features/shared/api"
import { useTranslation } from "react-i18next"
import { useSearchParams } from "react-router-dom"
import { localisedValue } from "../../../utils"
import { Card, ComponentState, Spinner, Text, Title } from "../../common"
import { LogoPropforce } from "../../svg"

export default function DiscountStatusCard() {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()

  const { data, isFetching, isError, error } = useVerifyDiscountStatusQuery(
    { slug: searchParams.get("slug"), status: searchParams.get("status") },
    { refetchOnMountOrArgChange: true }
  )

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
      className="p-24"
    >
      {isError ? (
        <Card className="text-center" style={{ maxWidth: "600px", height: "350px" }}>
          <ComponentState
            refetchRequired={false}
            btnLoading={isFetching}
            description={error?.message}
            status={error.status}
            title={t("Invalid URL")}
            displayExactMessage
          />
        </Card>
      ) : (
        <Card className="text-center" style={{ maxWidth: "600px", height: "350px", padding: "30px" }}>
          {isFetching ? (
            <Spinner style={{ marginTop: 100 }} />
          ) : (
            !isFetching && (
              <>
                <LogoPropforce width={228} height="auto" style={{ marginBottom: "20px" }} />
                <Title level={2} className="mbe-10" style={{ color: data?.data?.approved ? "#009432" : "#EF2D36" }}>
                  {t("Discount ")}
                  {data?.data?.approved ? t("Approved") : t("Rejected")}
                </Title>
                <Text
                  type="secondary"
                  className="text-center mbe-40"
                  style={{
                    color: "black",
                  }}
                >
                  {data?.data?.approved
                    ? `${t("The discount has been approved for ")} `
                    : `${t("The discount has been rejected for ")} `}
                  {localisedValue({ key: "projectName", object: data?.data })}
                  {": "}
                  {localisedValue({ key: "unitName", object: data?.data })}
                  <br />
                  {data?.data?.approved && (
                    <>
                      {t("The booking price for the requested unit has been updated.")}
                      <br />
                    </>
                  )}{" "}
                  {"----"}
                  <br />
                  {t("If this has happened by mistake, please contact Product Admin.")}
                </Text>
              </>
            )
          )}
        </Card>
      )}
    </div>
  )
}
